import { render, staticRenderFns } from "./GenericImagePanel.vue?vue&type=template&id=0c05ecfb&scoped=true"
import script from "./GenericImagePanel.vue?vue&type=script&lang=js"
export * from "./GenericImagePanel.vue?vue&type=script&lang=js"
import style0 from "./GenericImagePanel.vue?vue&type=style&index=0&id=0c05ecfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05ecfb",
  null
  
)

export default component.exports